import React from "react";
import { isMobile } from "react-device-detect";
import apple from "./apple.png";
import google from "./google-play.png";

export default function DownloadButtons({ small, notcentered }) {
  const buttonHeight = isMobile ? 50 : 60;

  const fontFamily =
    "'Nunito', system-ui, -apple-system, BlinkMacSystemFont, sans-serif";

  const wrapStyle = {
    display: "flex",
    flexDirection: notcentered || isMobile ? "column" : "row",
    alignItems: "center",
    justifyContent: "center",
    gap: notcentered || isMobile ? "10px" : "14px",
    width: "100%",
    transform: `scale(${isMobile ? 1 : small ? 0.85 : 1})`,
  };

  const buttonStyle = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "0 18px",
    height: buttonHeight,
    borderRadius: 12,
    backgroundColor: "#000",
    textDecoration: "none",
    boxShadow: "0 6px 16px rgba(0,0,0,0.25)",
    transition: "transform 0.15s ease, box-shadow 0.15s ease",
    fontFamily,
  };

  const textWrapStyle = {
    display: "flex",
    flexDirection: "column",
    lineHeight: 1.1,
    color: "#fff", // force text color
    fontFamily,
  };

  const smallText = {
    fontSize: 12,
    opacity: 0.85,
    fontWeight: 600,
    color: "#fff",
  };

  const bigText = {
    fontSize: 15,
    fontWeight: 700,
    color: "#fff",
  };

  const onHover = (e, lifted) => {
    e.currentTarget.style.transform = lifted
      ? "translateY(-1px)"
      : "translateY(0)";
    e.currentTarget.style.boxShadow = lifted
      ? "0 10px 22px rgba(0,0,0,0.3)"
      : "0 6px 16px rgba(0,0,0,0.25)";
  };

  return (
    <div style={wrapStyle}>
      {/* Apple */}
      <a
        href="https://apps.apple.com/us/app/id1636884270"
        target="_blank"
        rel="noreferrer"
        style={buttonStyle}
        onMouseEnter={(e) => onHover(e, true)}
        onMouseLeave={(e) => onHover(e, false)}
      >
        <img
          src={apple}
          alt="Apple App Store"
          style={{ height: isMobile ? 38 : 28 }}
        />
        <span style={textWrapStyle}>
          <span style={smallText}>Get it on</span>
          <span style={bigText}>Apple Store</span>
        </span>
      </a>

      {/* Google */}
      <a
        href="https://play.google.com/store/apps/details?id=com.fooge.app"
        target="_blank"
        rel="noreferrer"
        style={buttonStyle}
        onMouseEnter={(e) => onHover(e, true)}
        onMouseLeave={(e) => onHover(e, false)}
      >
        <img
          src={google}
          alt="Google Play Store"
          style={{ height: isMobile ? 30 : 26 }}
        />
        <span style={textWrapStyle}>
          <span style={smallText}>Get it on</span>
          <span style={bigText}>Google Play</span>
        </span>
      </a>
    </div>
  );
}
